import { ChartTypes } from '@mode/shared/contract-common';
import * as angular from 'angular';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MixableBaseController } from '~/common/component';
import { ActiveExplorationSelectors } from '~/selectors/active-exploration.selectors';
import { ClientDataService } from '~/services/client-data-service';
import { ModalService } from '@mode/shared/ui-angularjs';
import { AppStore } from '~/types/main.types';

class ExplorationContainer extends MixableBaseController implements angular.IOnInit {
  static $inject = ['ModalService', 'RxStoreService', 'ClientDataService'];

  explorationLoaded$: Observable<boolean>;
  objectContext = ChartTypes.ObjectType.Exploration;

  constructor(
    private modal: ModalService,
    private rxStore: AppStore,
    private clientDataService: ClientDataService
  ) {
    super();
  }

  $onInit(): void {
    this.explorationLoaded$ = this.rxStore
      .select(ActiveExplorationSelectors.getActiveExplorationToken)
      .pipe(map((token) => !!token));
  }
}

export const ID = 'explorationContainer';

export const explorationContainerComponent: angular.IComponentOptions = {
  template: `
  <div class="exploration-root">
    <platform-header
      header-style="Dark"
      is-local="true"
      menu-type="Report">
    </platform-header>
    <div class="exploration-container" ng-if="ctrl.explorationLoaded$ | async:this">
      <div class="results-content" ui-view></div>
    </div>
  </div>
  <!-- should these get moved to a parent? is there going to be a shared parent? maybe abstracted to a component? -->
  <view-data-lightbox-modal
    read-only="true"
    container="body"
  ></view-data-lightbox-modal>
  `,
  controller: ExplorationContainer,
  controllerAs: 'ctrl',
};
